export default function() {
  return new Worker(__webpack_public_path__ + "static/js/PyWorker.15fe3039.worker.js");
}
